const image1 = 'https://n.sinaimg.cn/spider20220215/292/w630h462/20220215/5c81-51a0e8c7b58c61769f25107f9015aea8.jpg';

export default {
  id: '20220215', //  模块 id
  title: '叮咚买菜2021年Q4营收54.8亿元 上海地区实现盈利', // 标题
  origin: '2022年02月15日 19:31   来源：TechWeb.com.cn', // 新闻来源
  editor: '编辑：老喵', // 编辑者
  content: [
    {
      type: 0,
      text:
        '【TechWeb】2月15日消息，美股盘前，叮咚买菜对外发布了截至2021年12月31日的第四季度业绩报告，数据显示，叮咚买菜第四季度实现营收54.8亿元，同比去年同期增长72.0%。2021年营收为201.2亿元，同比增长77.5%。',
      isIndent: true,
    },
    {
      type: 2,
    },
    {
      type: 0,
      text:
        '财报显示，第四季度叮咚买菜毛利率为27.7%，相比上个季度环比提升了9.5个百分点。毛利率的提升得益于叮咚买菜商品力的持续提升。Non-GAAP口径下，叮咚买菜四季度的履单费用率环比上季度优化了4.6个百分点。',
      isIndent: true,
    },
    {
      type: 2,
    },
    {
      type: 0,
      text:
        '在自有品牌商品方面，叮咚买菜拥有叮咚王牌菜、叮咚大满冠、拳击虾、保萝工坊、良芯匠人等共计超20个自有品牌，还将联手更多知名食品品牌，发挥各自的优势，不断提高新产品研发与品牌创新能力。        ',
      isIndent: true,
    },
    {
      type: 2,
    },
    {
      type: 0,
      text:
        '报告还称，叮咚买菜还将继续加大对研发的投入，尤其是在供应链系统、农业技术和食品研发等方面的基础设施建设的投入。        ',
      isIndent: true,
    },
    {
      type: 2,
    },
    {
      type: 0,
      text:
        '数据显示，截至第四季度，公司共拥有10个食品研发加工工厂；约60个城市分选中心和约1400个前置仓，前置仓面积达50万平方米。2022年还将开工建设3个大规模、现代化的生鲜综合体，以实现更高效地开发、生产与运输商品。        ',
      isIndent: true,
    },
    {
      type: 2,
    },
    {
      type: 0,
      text:
        '谈及本季度业绩，叮咚买菜创始人兼CEO梁昌霖表示：“第四季度是我们成立以来表现最好的一个季度，营收实现了高速增长，效率得到了显著优化，我们在高质量发展的快车道上。未来，消费升级和商品力是公司主要的增长动力，我们相信互联网的下半场会回归购物本质，商品力是第一推动力，要用优质的产品赢得用户，因此提高研发和生产加工能力，以及对供应链和基础设施进行长期投资，都是非常重要的。”         ',
      isIndent: true,
    },
    {
      type: 1,
      title: '',
      src: [image1],
    },
  ],
};
